export default "__VITE_ASSET__o_2YL9D1__"